module.exports = __webpack_public_path__ + "img/t_activity.ee27b06.webp";